function csvEscape(value) {
  const text = String(value ?? '')
  return /[",\n]/.test(text) ? `"${text.replace(/"/g, '""')}"` : text
}

function downloadBlob(content, filename, type) {
  const blob = new Blob([content], { type })
  const url = URL.createObjectURL(blob)
  const link = document.createElement('a')
  link.href = url
  link.download = filename
  document.body.appendChild(link)
  link.click()
  link.remove()
  URL.revokeObjectURL(url)
}

export function exportRecordsCsv(records, drivers, vehicles, filename = 'alcohol-check-records.csv') {
  const driverMap = Object.fromEntries(drivers.map((item) => [item.id, item.name]))
  const vehicleMap = Object.fromEntries(vehicles.map((item) => [item.id, item.number]))
  const headings = ['日付', '確認時刻', '区分', '確認者名', '運転者', '車両番号', '体調確認', '日常車両点検', '点呼・点検備考', '確認方法', '記録方法', '測定値(mg/L)', '酒気帯びの有無', '指示事項', 'その他必要事項']
  const rows = records.map((record) => {
    const driverIssues = DRIVER_CONDITION_ITEMS.filter((item) => record.preDriveCheck?.driverCondition?.[item.id] === 'review').map((item) => item.label)
    const vehicleIssues = VEHICLE_INSPECTION_ITEMS.filter((item) => record.preDriveCheck?.vehicleInspection?.[item.id] === 'review').map((item) => item.label)
    return [
      record.date, record.time, record.phase, record.confirmer, driverMap[record.driverId],
      vehicleMap[record.vehicleId], record.preDriveCheck ? driverIssues.length ? `要確認：${driverIssues.join('・')}` : '問題なし' : '—',
      record.preDriveCheck ? vehicleIssues.length ? `要確認：${vehicleIssues.join('・')}` : safetyStatusLabel(record.preDriveCheck) : '—', record.preDriveCheck?.note || '',
      record.confirmationMethod, record.method, Number(record.value).toFixed(2), record.confirmationMethod === '未確認' ? '管理者未確認' : record.presence ? '有' : '無', record.instruction, record.note,
    ]
  })
  const csv = `\uFEFF${[headings, ...rows].map((row) => row.map(csvEscape).join(',')).join('\r\n')}`
  downloadBlob(csv, filename, 'text/csv;charset=utf-8')
}

export function exportJson(data, filename = 'alco-log-integration.json') {
  downloadBlob(JSON.stringify(data, null, 2), filename, 'application/json;charset=utf-8')
}
import { DRIVER_CONDITION_ITEMS, VEHICLE_INSPECTION_ITEMS, safetyStatusLabel } from '../data/safetyChecks'
